import Dialog from 'components/Dialog';
import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {usePostApi} from 'common/hooks/usePostApi';
import api from 'api';
import history from 'redux/history';
import {packId} from 'common/diplomatIdUtil';
import actions from 'features/layout/redux/actions';
import FormikTextField from 'components/inputs/FormikTextField';
import {useTranslation} from 'react-i18next';
import {diplomatObjectSchema} from 'types/diplomat-object';
import {IDiplomatObject} from 'types/DiplomatObject';
import {FormFooterButtons} from 'components/buttons/FormFooterButtons';
import {ISftpUser} from 'types/diplomat/sftp/SftpUser';
import {DialogTypes} from 'common/names';
import {DiplomatObjectType} from 'types/DiplomatObjectType';
import Formik from 'components/hook-form/Formik';
import {layoutSelectors} from 'features/layout/redux';

type Props = {
   open?: boolean;
   data?: ISftpUser;
   onClose: () => void;
};

const CreateSftpGroupDialog = ({open = true, data, onClose}: Props) => {
   const {t} = useTranslation();
   const dispatch = useDispatch();
   const folderId = useSelector(layoutSelectors.sftpGroupsFolderId);
   const onSuccess = (data: ISftpUser) => {
      dispatch(actions.loadTreeNav());
      onClose();
      history.push(`/${packId(data.objectType, data.id)}`);
   };
   const {request} = usePostApi<ISftpUser>(api.vfsgroups, {onSuccess, onFailure: onClose});
   const handleSubmit = (values: IDiplomatObject) => {
      request(
         JSON.stringify({
            group: {
               ...values,
               // overwrite: true,
               objectType: DiplomatObjectType.enum.VFS_GROUP,
               suspended: false,
            },
            folderId: data?.id || folderId,
            overwrite: false,
         })
         // {
         //    searchParams: {folderId: data?.id || folderId!},
         // }
      );
   };
   return (
      <Dialog
         maxWidth="sm"
         header={DialogTypes.CreateSftpGroup.dialogName}
         open={open}
         close={onClose}
      >
         <Formik
            initialValues={diplomatObjectSchema.cast({
               name: '',
            })}
            onSubmit={handleSubmit}
         >
            <>
               <FormikTextField autoFocus required label={t('New Group Name:')} name={'name'} />
               <FormFooterButtons cancel={onClose} />
            </>
         </Formik>
      </Dialog>
   );
};

export default CreateSftpGroupDialog;
